import React, { useState, useEffect } from "react";
import { Button, Spinner, Alert } from "react-bootstrap";
import _ from "lodash";
import QuaidsQuoteSection from "./LeadershipComponents/QuaidsQuoteSection";
import CmPunjabSection from "./LeadershipComponents/CmPunjabSection";
import LeadershipMessagesSection from "./LeadershipComponents/LeadershipMessagesSection";
import TeamSection from "./LeadershipComponents/TeamSection";
import MetaSection from "./LeadershipComponents/MetaSection";
import { sanitizeData } from ".";

const LeadershipEditor = ({ data, onSave, onCancel, isLoading }) => {
  const defaultStructure = {
    quaidsQuoteSection: {
      isVisible: true,
      quote: "",
      author: "",
      designation: "",
      note: "",
      image: "",
    },
    cmPunjabSection: {
      isVisible: true,
      heading: "",
      message: "",
      author: "",
      image: "",
    },
    leadershipMessages: [
      {
        isVisible: true,
        id: "",
        title: "",
        message: "",
        author: "",
        designation: "",
        image: "",
        imagePosition: "",
      },
    ],
    teamSection: {
      isVisible: true,
      heading: "",
      subHeading: "",
      teamMembers: [
        {
          id: "",
          name: "",
          designation: "",
          image: "",
        },
      ],
    },
    meta: {
      title: "",
      description: "",
    },
  };

  const [formData, setFormData] = useState(defaultStructure);
  const [alert, setAlert] = useState({ show: false, message: "", variant: "info" });

  useEffect(() => {
    if (data?.content) {
      setFormData({ ...defaultStructure, ...data.content });
    }
  }, [data]);

  const handleSectionUpdate = (sectionName, sectionData) => {
    setFormData((prev) => ({
      ...prev,
      [sectionName]: sectionData,
    }));
  };

  const handleSave = () => {
    const sanitizedData = sanitizeData(formData, defaultStructure);
    onSave({ pageName: data.pageName, content: sanitizedData });
  };

  return (
    <div className="col-12">
      {alert.show && (
        <Alert
          variant={alert.variant}
          dismissible
          onClose={() => setAlert({ show: false, message: "", variant: "info" })}
          className="mb-3"
        >
          {alert.message}
        </Alert>
      )}

      <div className="card p-4">
        <div className="d-flex align-items-center justify-content-between mb-4">
          <div className="d-flex align-items-center">
            <Button variant="link" className="p-0 me-3" onClick={onCancel}>
              ← Back
            </Button>
            <h4 className="m-0">Edit Leadership Page</h4>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <QuaidsQuoteSection
              data={formData.quaidsQuoteSection}
              onUpdate={(data) =>
                handleSectionUpdate("quaidsQuoteSection", data)
              }
            />

            <CmPunjabSection
              data={formData.cmPunjabSection}
              onUpdate={(data) => handleSectionUpdate("cmPunjabSection", data)}
            />

            <LeadershipMessagesSection
              data={formData.leadershipMessages}
              onUpdate={(data) =>
                handleSectionUpdate("leadershipMessages", data)
              }
            />

            <TeamSection
              data={formData.teamSection}
              onUpdate={(data) => handleSectionUpdate("teamSection", data)}
            />

            <MetaSection
              data={formData.meta}
              onUpdate={(data) => handleSectionUpdate("meta", data)}
            />

            <div className="d-flex justify-content-end gap-2">
              <Button variant="secondary" onClick={onCancel}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleSave} disabled={isLoading}>
                {isLoading ? (
                  <>
                    <Spinner animation="border" size="sm" className="me-2" />
                    Saving...
                  </>
                ) : (
                  "Save Changes"
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LeadershipEditor;
